// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2H4rM","content":"style_content__2Lu3W"};